module.exports = __webpack_public_path__ + "img/Destacado002.c85de3b7.jpeg";